module.exports = __webpack_public_path__ + "img/intro_3.4dc49ca.png";